import { connect } from 'react-redux';
import React from 'react';
import {
    LinkContainer as SourceLinkContainer,
    mapStateToProps,
    mapDispatchToProps,
} from 'SourceComponent/Link/Link.container';
import LinkComponent from './Link.component';

export {
    mapStateToProps,
    mapDispatchToProps,
};

export class LinkContainer extends SourceLinkContainer {
    // shouldComponentUpdate() {
    //     return false;
    // }
}

export default connect(mapStateToProps, mapDispatchToProps)(LinkContainer);
